/* Mobile-only proxy for the existing product Add to Cart button. */
(() => {
  if (window.nihilMobileStickyAtcLoaded) return;
  window.nihilMobileStickyAtcLoaded = true;
  const mobile = window.matchMedia(
  '(max-width: 749px), (min-width: 750px) and (max-width: 1024px) and (orientation: portrait) and (any-pointer: coarse)');
  const controllers = new Map();

  function init(section) {
    if (controllers.has(section) || section.closest('quick-add-modal')) return;
    const bar = document.createElement('div');
    bar.className = 'nihil-mobile-sticky-atc';
    bar.hidden = true;
    const proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = 'nihil-mobile-sticky-atc__button';
    proxy.textContent = 'Add to Cart';
    bar.append(proxy);
    document.body.append(bar);
    let frame = 0;
    let stopped = false;

    function originalButton() {
      return Array.from(section.querySelectorAll('.product__info-container .product__buy_buttons .product-form__submit[name="add"]'))
        .find(button => button.getClientRects().length > 0);
    }

    function sizeTarget() {
      const info = section.querySelector('.product__info-container');
      if (!info) return null;
      const heading = info.querySelector('.nihil-selected-size-stock');
      if (heading) return heading.closest('fieldset') || heading;
      const grid = info.querySelector('.nihil-size-grid');
      return grid ? (grid.closest('fieldset') || grid) : null;
    }

    function update() {
      frame = 0;
      if (stopped) return;
      if (!section.isConnected) { destroy(); return; }
      const original = originalButton();
      const overlayOpen = document.body.classList.contains('overflow-hidden') ||
        !!document.querySelector('cart-drawer.active, cart-drawer.notification-open, .cart-drawer.notification-open, quick-add-modal[open], modal-dialog[open], product-modal[open]');
      const belowScreen = original && original.getBoundingClientRect().top >= window.innerHeight;
      bar.hidden = !mobile.matches || !original || !belowScreen || overlayOpen;
      if (!original) return;
      const label = original.querySelector('span');
      const busy = original.classList.contains('loading');
      const hasSizes = !!sizeTarget();
      proxy.disabled = hasSizes ? false : (original.disabled || original.getAttribute('aria-disabled') === 'true' || busy);
      proxy.textContent = hasSizes ? 'Select size' : (busy ? 'Adding…' : (label ? label.textContent.trim() : original.textContent.trim()));
      if (original.getAttribute('aria-haspopup')) proxy.setAttribute('aria-haspopup', original.getAttribute('aria-haspopup'));
      else proxy.removeAttribute('aria-haspopup');
      proxy.setAttribute('aria-busy', String(busy));
    }

    function schedule() {
      if (!frame && !stopped) frame = window.requestAnimationFrame(update);
    }

    proxy.addEventListener('click', (event) => {
      const original = originalButton();
      const target = sizeTarget();
      if (target) {
        // Scroll only enough to reveal the size options and original buy button.
        // Do not align the size fieldset with the top of the screen.
        const viewport = window.visualViewport;
        const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
        const bottom = Math.max(target.getBoundingClientRect().bottom, original ? original.getBoundingClientRect().bottom : 0);
        const startY = window.scrollY;
        const documentLimit = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const destination = Math.min(documentLimit, startY + Math.max(0, bottom - viewportBottom + 24));
        const distance = destination - startY;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const keyboardClick = event.detail === 0;
        let cancelled = false;
        const cancel = () => { cancelled = true; cleanup(); };
        function cleanup() {
          window.removeEventListener('touchstart', cancel);
          window.removeEventListener('wheel', cancel);
        }
        function finish() {
          cleanup();
          if (keyboardClick && target.isConnected) {
            target.setAttribute('tabindex', '-1');
            target.focus({preventScroll: true});
          }
          schedule();
        }
        if (reduceMotion || distance <= 1) {
          window.scrollTo({top: destination, behavior: 'instant'});
          finish();
          return;
        }
        window.addEventListener('touchstart', cancel, {passive: true});
        window.addEventListener('wheel', cancel, {passive: true});
        const started = performance.now();
        function animate(now) {
          if (cancelled || stopped || !section.isConnected) { cleanup(); return; }
          const progress = Math.min(1, (now - started) / 600);
          const eased = 1 - Math.pow(1 - progress, 3);
          window.scrollTo({top: startY + distance * eased, behavior: 'instant'});
          if (progress < 1) window.requestAnimationFrame(animate);
          else finish();
        }
        window.requestAnimationFrame(animate);
        return;
      }
      if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
      // One-size products still submit through the original button.
      original.click();
      schedule();
      // Keep existing gift-card/form validation and errors visible.
      window.setTimeout(() => {
        if (!section.isConnected) return;
        const error = section.querySelector('.product__info-container .product-form__error-message-wrapper:not([hidden])');
        if (error && error.textContent.trim()) error.scrollIntoView({block: 'center', behavior: 'smooth'});
      }, 600);
    });

    const observer = new MutationObserver(schedule);
    observer.observe(section, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'hidden']});
    const bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});
    const drawer = document.querySelector('cart-drawer');
    const drawerObserver = new MutationObserver(schedule);
    if (drawer) drawerObserver.observe(drawer, {subtree: true, attributes: true, attributeFilter: ['class', 'open']});
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule);
    mobile.addEventListener('change', schedule);

    function destroy() {
      stopped = true;
      if (frame) window.cancelAnimationFrame(frame);
      observer.disconnect();
      bodyObserver.disconnect();
      drawerObserver.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      mobile.removeEventListener('change', schedule);
      bar.remove();
      controllers.delete(section);
    }
    controllers.set(section, {destroy});
    schedule();
  }

  function initAll() {
    document.querySelectorAll('section[id^="MainProduct-"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once: true});
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((controller, section) => {
      if (event.target === section || event.target.contains(section)) controller.destroy();
    });
  });
})();